module.exports = window["core-js/modules/es.object.get-prototype-of.js"];